import { database, businessDb } from '@shared/database'

export default {
  namespaced: true,
  state: {
    offerCount: 0,
    isInitialized: false
  },
  mutations: {
    setOfferCount(state, count) {
      state.offerCount = count
    },
    setIsInitialized(state, value) {
      state.isInitialized = value
    }
  },
  actions: {
    updateOfferCount({ commit }, count) {
      commit('setOfferCount', count)
    },
    resetOfferCount({ commit }) {
      commit('setOfferCount', 0)
    },
    async initializeOfferCount({ commit, dispatch, rootState }) {
      // すでに初期化済みの場合は何もしない
      if (rootState.auth.isAuthenticating || !rootState.auth.isLoggedIn) return

      const uid = rootState.auth.uid
      if (!uid) return

      // オファー数の初期取得
      await dispatch('fetchOfferCount', uid)

      // 定期的な更新を開始
      setInterval(() => dispatch('fetchOfferCount', uid), 60000)

      commit('setIsInitialized', true)
    },
    async fetchOfferCount({ commit }, uid) {
      try {
        if (!uid) return

        const user = await database.userCollection().findById(uid)
        if (!user || !user.accessibleUserId) return

        const offers = await database
          .orderOfferCollectionGroup()
          .getPendingOffersByWorkerId(user.accessibleUserId)

        const validOffers = await Promise.all(
          offers.map(async (offer) => {
            try {
              if (offer.status !== 'pending') return null

              const order = await businessDb
                .orderCollection(offer.companyId)
                .findById(offer.orderId)

              if (!order) return null

              if (order.deadline) {
                const deadline = order.deadline.toDate()
                if (deadline < new Date()) return null
              }

              return offer
            } catch (error) {
              console.error('order fetch error:', error)
              return null
            }
          })
        )

        const count = validOffers.filter((offer) => offer !== null).length
        commit('setOfferCount', count)
      } catch (error) {
        console.error('オファー数の取得に失敗しました:', error)
        commit('setOfferCount', 0)
      }
    }
  }
}
